import { useState } from 'react';
import * as yup from 'yup';
import { axiosInstance } from '../../../../api/axios';
import APIEndpoints from '../../../api/APIEndpoints';
import { HttpSuccessCodes } from '../../../errorhandling/HttpErrorCodes';

const useEmailRecovery = ({ setUserDetails, passwordRules }) => {
  const [loader, setLoader] = useState(false);
  const schema = yup.object({
    email: yup
      .string()
      .required('Email id is required!')
      .email('Please enter valid email !'),
  });

  const checkUser = async (email) => {
    try {
      setLoader(true);
      const response = await axiosInstance.get(APIEndpoints.GetUser() + email);
      const getUserDataResp = response.data;
      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        if (getUserDataResp.Response.User.Status === 'Disabled') {
          return new Promise((resolve, reject) => {
            setLoader(false);
            reject(
              'Your user account has been disabled. Please contact our customer support team.',
            );
          });
        } else if (
          getUserDataResp.Response.User.Status === 'Pending Registration'
        ) {
          return new Promise((resolve, reject) => {
            setLoader(false);
            reject(
              'You have not yet Registered. Register yourself or contact our customer support team',
            );
          });
        } else if (
          getUserDataResp.Response.User.UserType !== 'Client' &&
          getUserDataResp.Response.User.UserType !== 'Insurer' &&
          getUserDataResp.Response.User.UserType !== 'Broker'
        ) {
          setLoader(false);
          return new Promise((resolve, reject) => {
            reject(
              'Email address provided was not found. Please use correct email or contact administrator.',
            );
          });
        } else if (
          getUserDataResp.Response.User.Status === 'Locked' &&
          passwordRules.AllowUnlockDisabledLogin === 'false'
        ) {
          setLoader(false);
          return new Promise((resolve, reject) => {
            reject(
              'Your user account has been locked. Please use correct email or contact administrator.',
            );
          });
        } else {
          const payload = {
            Oid: getUserDataResp.Response.User.Oid,
            Status: getUserDataResp.Response.User.Status,
            SuperUser: getUserDataResp.Response.User.SuperUser,
          };
          setUserDetails(payload);
          setLoader(false);
          return new Promise((resolve, reject) => {
            resolve('success');
          });
        }
      } else {
        setLoader(false);
        return new Promise((resolve, reject) => {
          reject('We are unable to get user details now.');
        });
      }
    } catch (e) {
      if (e.response.status === 404) {
        setLoader(false);
        return new Promise((resolve, reject) => {
          reject(
            'Email address provided was not found. Please use correct email or contact administrator.',
          );
        });
      } else {
        setLoader(false);
        return new Promise((resolve, reject) => {
          reject('We are unable to get user details now.');
        });
      }
    }
  };

  return {
    schema,
    checkUser,
    loader,
  };
};
export default useEmailRecovery;
